import React from 'react';
import { Button } from 'reactstrap';

const UpdateSitemap = ({ t, icon, onClick, isUpdating }) => (
  <Button color="warning" disabled={isUpdating} onClick={onClick} className="btn-brand"><i className={icon} />{t('Update sitemap')}</Button>
);

export default UpdateSitemap;



// WEBPACK FOOTER //
// ./src/views/settings/components/updateSitemap/UpdateSitemap.jsx